import request from '@/utils/request'
/**
 * @apiName 项目分页列表查询
 * @param  data {pageNum,pageSize,id,itemType,maintenanceType,storeId,cityName,state,collaborationId,serviceId}
 */
export function maintenancePageListApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/item/pageList',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 项目详情
 * @param  data {id:项目ID}
 */
export function maintenanceDetailtApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/item/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 项目名称模糊查询
 * @param  data {name:名称}
 */
export function maintenanceLikeByNameApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/item/likeByName',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 门店名称模糊查询
 * @param  data {name:名称}
 */
export function maintenanceStoreLikeByNameApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/store/likeByName',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 查询门店的城市集合
 * @param  data {name:名称}
 */
export function maintenanceStoreListAllCityApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/store/listAllCity',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 服务商名称模糊查询
 * @param  data - {name:名称}
 */

export function getCompanyProviderLikeByNameApi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/likeByName',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 查询所有租赁方案
 * @param  data - {rentPlanType:租赁方案类型  1 "个人租赁方案"  2 "企业租赁方案,name:租赁方案名称模糊查询,ids:租赁方案ID集合}
 */

export function getRentPlanListAPi(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/plan/listForMaintenance',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 创建租赁关系绑定记录
 * @param  data - {itemId:项目ID,idAndHandelWays:[{id:ID,handleWay:处理方式  0, "覆盖" 1, "追加"  2, "不处理"}]}
 */

export function createItemRentPlanLinkApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/itemRentPlanLink/create',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 创建用户绑定记录
 * @param  data - {itemId:项目ID,idAndHandelWays:[{id:ID,handleWay:处理方式  0, "覆盖" 1, "追加"  2, "不处理"}]}
 */

export function createOrderLinkApi(data = {}) {
  return request({
    url: '/admin/v1/maintenance/orderLink/create',
    method: 'POST',
    data,
  })
}


export const createBindrecordApi = new Map([
  ['scheme', createItemRentPlanLinkApi],
  ['order', createOrderLinkApi],
])
